__turbopack_context__.v({
  "active": "search-bar-module___BAmnG__active",
  "blok-big-title": "search-bar-module___BAmnG__blok-big-title",
  "blok-subtitle": "search-bar-module___BAmnG__blok-subtitle",
  "blok-title": "search-bar-module___BAmnG__blok-title",
  "search-form": "search-bar-module___BAmnG__search-form",
});
